export interface OversizedFile {
    file: File;
    limit: number;
}

function formatFileSizeLimit(limit: number): string {
    const megabytes = limit / (1024 * 1024);
    return `${Number.isInteger(megabytes) ? megabytes : megabytes.toFixed(1)}MB`;
}

export function formatOversizedFiles(files: OversizedFile[]): string {
    return files.map(({ file, limit }) => `${file.name} (${formatFileSizeLimit(limit)} limit)`).join(", ");
}
